import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import { AppletLabelListContainerModel } from '../../../../../../models/aggregates/applet/label';

@Injectable({providedIn: 'root'})

export class AppletLabelListService extends BaseApiTemplateService<AppletLabelListContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-label-lists';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-label-lists';
    this.httpClient = http;
  }

}
